var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "page"
  }, [_c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('avp-breadcrumbs'), _c('v-form', {
    ref: "form"
  }, [_c('v-row', {
    staticClass: "d-flex justify-center mt-3"
  }, [_c('v-col', {
    attrs: {
      "cols": "2"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Nome De Usuário",
      "outlined": "",
      "dense": ""
    },
    model: {
      value: _vm.form.filters.nome,
      callback: function ($$v) {
        _vm.$set(_vm.form.filters, "nome", $$v);
      },
      expression: "form.filters.nome"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "2"
    }
  }, [_c('v-text-field', {
    directives: [{
      name: "mask",
      rawName: "v-mask",
      value: '###.###.###-##',
      expression: "'###.###.###-##'"
    }],
    attrs: {
      "label": "CPF",
      "outlined": "",
      "dense": ""
    },
    model: {
      value: _vm.form.filters.login,
      callback: function ($$v) {
        _vm.$set(_vm.form.filters, "login", $$v);
      },
      expression: "form.filters.login"
    }
  })], 1), _c('avp-select-ano-semestre', {
    attrs: {
      "cols": 3,
      "sufix": 'do Ciclo',
      "disabled": _vm.disabledAnoSemestre,
      "active": _vm.form.filters.active,
      "required": "",
      "all": ""
    },
    model: {
      value: _vm.form.filters,
      callback: function ($$v) {
        _vm.$set(_vm.form, "filters", $$v);
      },
      expression: "form.filters"
    }
  }), _c('v-col', {
    attrs: {
      "cols": "2"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "label": "Perfil",
      "items": _vm.form.lists.listPerfis,
      "item-text": 'nome',
      "item-value": 'id',
      "outlined": "",
      "dense": ""
    },
    on: {
      "change": function (perfilId) {
        return _vm.desabilitarCiclo(perfilId);
      }
    },
    model: {
      value: _vm.form.filters.perfil,
      callback: function ($$v) {
        _vm.$set(_vm.form.filters, "perfil", $$v);
      },
      expression: "form.filters.perfil"
    }
  })], 1), _c('avp-select-ativo', {
    attrs: {
      "cols": 2
    },
    model: {
      value: _vm.form.filters.ativo,
      callback: function ($$v) {
        _vm.$set(_vm.form.filters, "ativo", $$v);
      },
      expression: "form.filters.ativo"
    }
  })], 1), _c('div', {
    staticClass: "text-center"
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('avp-tooltip', {
    attrs: {
      "text": 'Buscar',
      "icon": 'mdi-magnify'
    },
    on: {
      "click": function ($event) {
        return _vm.buscarUsuarios();
      }
    }
  }), _c('avp-tooltip', {
    attrs: {
      "text": 'Limpar',
      "icon": 'mdi-eraser'
    },
    on: {
      "click": function ($event) {
        return _vm.resetForm();
      }
    }
  }), _c('avp-tooltip', {
    attrs: {
      "text": 'Novo',
      "icon": 'mdi-plus'
    },
    on: {
      "click": function ($event) {
        return _vm.openDialogManterUsuario();
      }
    }
  })], 1)], 1)], 1), _c('v-data-table', {
    staticClass: "mt-5",
    attrs: {
      "headers": _vm.headers,
      "items": _vm.form.lists.listUsuarios,
      "items-per-page": 10,
      "footer-props": _vm.$footerProps,
      "sort-by": "nome",
      "show-expand": ""
    },
    scopedSlots: _vm._u([{
      key: `item.nome`,
      fn: function (_ref) {
        var item = _ref.item;
        return [_vm._v(" " + _vm._s(item.nome) + " ")];
      }
    }, {
      key: `item.usuario`,
      fn: function (_ref2) {
        var item = _ref2.item;
        return [_vm._v(" " + _vm._s(_vm.$formatCpf(item.cpf)) + " ")];
      }
    }, {
      key: `item.perfil`,
      fn: function (_ref3) {
        var item = _ref3.item;
        return [_vm._v(" " + _vm._s(item.perfil) + " ")];
      }
    }, {
      key: `item.ativo`,
      fn: function (_ref4) {
        var item = _ref4.item;
        return [_c('avp-label-ativo', {
          attrs: {
            "ativo": item.ativo
          }
        })];
      }
    }, {
      key: `item.acoes`,
      fn: function (_ref5) {
        var item = _ref5.item;
        return [_c('avp-tooltip', {
          attrs: {
            "text": 'Visualizar Usuario',
            "icon": 'mdi-eye-outline',
            "small": true
          },
          on: {
            "click": function ($event) {
              return _vm.openDialogVisualizarUsuario(item);
            }
          }
        }), _vm.form.filters.ano !== 'Todos' || _vm.varificarSeTemPerfilAdm(item) ? _c('avp-tooltip', {
          attrs: {
            "text": 'Editar Usuario',
            "icon": 'mdi-pencil',
            "small": true
          },
          on: {
            "click": function ($event) {
              return _vm.openDialogManterUsuario(item);
            }
          }
        }) : _vm._e(), _c('avp-tooltip', {
          attrs: {
            "text": `${item.ativo ? 'Inativar' : 'Ativar'} Usuario`,
            "icon": `${item.ativo ? 'mdi-toggle-switch-off' : 'mdi-toggle-switch'}`,
            "small": true
          },
          on: {
            "click": function ($event) {
              return _vm.inativarAtivarUsuario(item);
            }
          }
        })];
      }
    }, {
      key: "expanded-item",
      fn: function (_ref6) {
        var headers = _ref6.headers,
            item = _ref6.item;
        return [_c('td', {
          staticClass: "grupos",
          attrs: {
            "colspan": headers.length
          }
        }, [_c('v-chip-group', {
          attrs: {
            "active-class": "primary--text",
            "column": ""
          }
        }, _vm._l(item.perfis, function (grupo, i) {
          return _c('v-chip', {
            key: i,
            staticClass: "chip-permissao"
          }, [_c('v-icon', {
            staticClass: "grupo",
            attrs: {
              "small": ""
            }
          }, [_vm._v("mdi-account-multiple")]), _vm._v(" " + _vm._s(grupo.nome) + " ")], 1);
        }), 1)], 1)];
      }
    }], null, true)
  })], 1), _c('CadastrarEditarUsuarioDialog', {
    attrs: {
      "visible": _vm.dialogManterUsuario.visible,
      "content": _vm.dialogManterUsuario.content,
      "edit": _vm.dialogManterUsuario.edit
    },
    on: {
      "onClose": function ($event) {
        return _vm.dialogManterUsuario.close();
      },
      "onSave": function ($event) {
        return _vm.buscarUsuarios();
      }
    }
  }), _c('VisualizarUsuarioDialog', {
    attrs: {
      "visible": _vm.dialogVisualizarUsuario.visible,
      "content": _vm.dialogVisualizarUsuario.content
    },
    on: {
      "onClose": function ($event) {
        return _vm.dialogVisualizarUsuario.close();
      }
    }
  })], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }